import { Checkbox, Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { TOGGLE_SELECT_MEDICATION_PRESCRIPTION } from "../../../actions/type";
import { AssetStore } from "../../../assets/AssetsStore";
import { BlackAdd, BlueAdd, ClockSmall } from "../../../assets/Logos/Icons";
import PrescriptionDropDown from "../../PrescriptionDropdown/PrescriptionDropDown";

import AddMedicineModal from "../../PrintPrescription/Components/Modals/AddDataModal/AddDataModal";
import { PrescriprionContext } from "../../PrintPrescription/PrintPrescription";
import Searchbox from "../SearchBox/Searchbox";
import styles from "./index.module.scss";
import Textarea from "react-expanding-textarea";

function InvestigationBox({
  name,
  addTitle,
  initialData,
  selectedData,
  handleSearch,
  handleAdd,
  toggle,
  detailedData,
}) {
  const [isOpen, setOpne] = useState(false);
  const [isAddOpen, setAddOpen] = useState(false);
  const [selected, setSelected] = useState(false);
  const [searchValues, setSearchValues] = useState([]);
  const [detailKeys, setDetailKeys] = useState([]);
  const [currentDetailData, setCurrentDetailData] = useState({});
  const [selectedMedicineId, setSelectedMedicineId] = useState(null);
  const [selectedMedicineGenericname, setSelectedMedicineGenericName] =
    useState(null);
  const [selectedMedicData, setSelectedMedicData] = useState([]);
  const [selectedDetailData, setSelectedDetailData] = useState({});
  const { wholeData, handleWholeData } = useContext(PrescriprionContext);

  useEffect(() => {
    console.info("wholeData", wholeData);
    //if (detailedData?.length) {
    // setDetailKeys(Object.keys(detailedData[0]));
    // setCurrentDetailData(detailedData[0]);
    if (selectedMedicineId) {
      setSelectedDetailData(
        selectedMedicData.filter((item) => item.name === selectedMedicineId)[0]
          ?.detailData ?? {}
      );
    }
    //}
  }, [selectedMedicineId, detailedData]);

  const [sinceOption, setSinceOption] = useState([
    { label: "1d", value: "1d" },
    { label: "2d", value: "2d" },
    { label: "3d", value: "3d" },
    { label: "4d", value: "4d" },
    { label: "5d", value: "5d" },
    { label: "6d", value: "6d" },
    { label: "week", value: "week" },
    { label: "10d", value: "10d" },
  ]);

  const dispatch = useDispatch();

  const quickQuantity = ["1", "1.5", "2.5", "4", "5", "7.5", "10"];
  let units = ["GRAMS", "MCG", "MG", "MG/ML", "ML", "NUM", "μm", "PERCENTAGE"];

  const freequancy = {
    l1: [
      "1d",
      "2d",
      "3d",
      "4d",
      "5d",
      "1w",
      "10d",
      "2w",
      "12d",
      "3w",
      "Once",
      "Twice",
      "Thrice",
      "4 times",
    ],
    l2: [],
    l3: [],
  };

  const timing = {
    l1: [
      "4h",
      "6h",
      "8h",
      "12h",
      "48h",
      "Once",
      "Twice",
      "Thrice",
      "4times",
      "1-0-1",
      "1-1-1",
      "1-0-0",
      "0-0-1",
      "0-1-1",
      "1-1-0",
    ],
    l2: ["Before Food", "After Food", "Empty Stomach", "Bedtime", "SOS"],
    l3: [],
    l4: [],
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  useEffect(() => {
    setSearchValues(createSearchOptionsWithData(initialData));
  }, [initialData]);

  const addData = (e) => {
    handleAdd(e.name);
    handleSelectData({ name: e.name });
  };

  const handleAddSubmit = (name) => {
    handleAdd(name);
    setSelectedMedicineId(name.name);

    handleSelectData(name);
    setSelected(() => name);
    setOpne(true);
  };

  const handleItemClick = (name) => {
    console.info("handleItemClick", name);
    setSelectedMedicineId(name.name);

    if (
      selectedMedicData.filter((item) => item.name === name.name).length > 0
    ) {
      console.info("here");
      handleUnSelectData(name);
    } else {
      console.info("here else");
      handleSelectData(name);
    }
    if (isSelected(name)) {
      if (isOpen) {
        setOpne(false);
      } else {
        setSelected(() => name);
        setOpne(true);
      }
    } else {
      toggle(name);
      setSelected(() => name);
      setOpne(true);
    }
  };

  const handleItemClickSelected = (name) => {
    setSelectedMedicineId(name.name);
    setSelectedMedicineGenericName(name.genericname);
    if (isSelected(name) && selected?.name === name) {
      if (isOpen) {
        setOpne(false);
      } else {
        setSelected(() => name);
        setOpne(true);
      }
    } else {
      setSelected(() => name);
      setOpne(true);
    }
  };

  const isSelected = (params) => {
    let { name } = params;
    let data = selectedMedicData;
    if (data && data.length > 0) {
      let res = data.filter((e) => e.name === name);

      return res && res.length > 0;
    }
  };

  const pushToWholeData = (key, data) => {
    handleWholeData(key, data);
  };

  useEffect(() => {
    if (selectedMedicData?.length > 0) {
      pushToWholeData("investigations", selectedMedicData);
    }
  }, [selectedMedicData]);

  const handleSubmissionData = (items) => {
    setSelectedMedicData(items);
  };

  useEffect(() => {
    if (wholeData.investigations != selectedMedicData) {
      handleSubmissionData(wholeData.investigations);
      if (wholeData.investigations?.length > 0) {
        setSelectedMedicineId(wholeData.investigations[0].name);

        setOpne(true);
      }
    }
  }, [wholeData.investigations]);

  const createSearchOptionsWithData = (data) => {
    if (data && data.length > 0) {
      let result = [];
      data.map((e) => result.push({ label: e?.name, value: e?.name }));
      return result;
    } else {
      return [];
    }
  };

  // const handleSubChange = ({ key, value }) => {
  //   let newSubmissionSymptoms = [...selectedData];
  //   newSubmissionSymptoms.map((each) => {
  //     if (each.name === selected) {
  //       each[key] = value;
  //     }
  //   });

  //   dispatch({
  //     type: TOGGLE_SELECT_MEDICATION_PRESCRIPTION,
  //     payload: newSubmissionSymptoms,
  //   });
  // };

  // const isSubSelected = (key, value) => {
  //   let indexData = selectedData.filter((e) => e.name === selected)[0];
  //   return indexData && indexData[key] === value;
  // };

  const isSubSelected = (key, value) => {
    if (selectedDetailData && Object.keys(selectedDetailData).includes(key)) {
      return selectedDetailData[key].includes(value);
    } else {
      return false;
    }
  };

  const getSubValue = (key) => {
    if (selectedDetailData?.length) {
      let indexData = selectedDetailData?.filter((e) => e.name === selected)[0];
      return indexData ? indexData?.detailData[key] : "";
    }
    return "";
  };

  const handleSelectData = (data) => {
    setSelectedMedicData([...selectedMedicData, data]);
    setSelectedDetailData({});
  };

  const handleUnSelectData = (data) => {
    const newSelectedMedicData = selectedMedicData.filter((item) => item.name !== data.name);
    setSelectedMedicData(newSelectedMedicData);
    pushToWholeData("investigations", newSelectedMedicData);
  };

  let handleAddIconClick = (e, name) => {
    if (
      selectedMedicData.filter((item) => item.name === name.name).length > 0
    ) {
      handleUnSelectData(name);
    } else {
      handleSelectData(name);
    }
    setSelectedMedicineId(name.name);
    setSelectedMedicineGenericName(name.genericname);
    e.stopPropagation();
    toggle(name);
    setOpne(false);
  };

  let isNumber = (e) => {
    let value = e?.target?.value;
    var rgx = /^[0-9]*\.?[0-9]*$/;
    return value?.match(rgx);
  };

  let isNumberAndText = (e) => {
    let value = e?.target?.value;
    var rgx = /^[A-Za-z0-9]*$/;
    return value?.match(rgx);
  };

  const isAnArray = (data) => {
    return Array.isArray(data);
  };

  const handleSearchBox = (value) => {
    let _item = initialData.filter((e) => e.name == value)[0];
    let _isSelected = selectedData.filter((e) => e.name == value)[0];
    console.info("_item", _item);
    if (!_isSelected) {
      toggle(_item);
      setSelectedMedicineId(_item.name);
      handleSelectData(_item);
    }
    setSelected(() => _item);
    setOpne(true);
    setSearchValues(createSearchOptionsWithData(initialData));
  };

  const handleSearchBoxs = (value) => {
    console.info("handleSearchBox", selectedMedicData);
    let _item = initialData.filter((e) => e.name == value)[0];
    let _isSelected = selectedMedicData.filter((e) => e.name == value)[0];

    console.info("_item", _item);
    console.info("_isSelected", _isSelected);
    if (!_isSelected) {
      // toggle(_item);
      setSelectedMedicineId(_item.name);
      setSelectedMedicineGenericName(_item.genericname);
      handleSearch(_item);
      handleSelectData(_item);
    }

    setSelected(() => _item);
    setOpne(true);

    setSearchValues(createSearchOptionsWithData(initialData));
  };

  const isInSearch = (e, data) => {
    for (let i = 0; i < e.length; i++) {
      if (e[i].toLowerCase() !== data?.name[i].toLowerCase()) {
        return false;
      }
    }
    return true;
  };

  const handleOnSearch = (e) => {
    if (initialData && initialData.length > 0 && e) {
      let filterData = initialData.filter((option) => isInSearch(e, option));
      setSearchValues(createSearchOptionsWithData(filterData));
    } else setSearchValues([]);
  };

  const handleOnTimingCheck = (value) => {
    handleSubChange({ key: "default_timing_custom", value });
  };

  const handleAutoCompleteOptions = (e) => {
    setSinceOption(sinceOption.filter((item) => item.name.indexOf(e) > -1));
  };

  const handleSubChange = ({ key, value }) => {
    console.info("handleSubChange", key, value);
    let newSubmissionData = { ...selectedDetailData };
    const keys = Object.keys(newSubmissionData);
    if (!keys.length) {
      newSubmissionData = { [key]: [value] };
    } else if (keys.includes(key)) {
      if (newSubmissionData[key].includes(value)) {
        delete newSubmissionData[key];
      } else {
        newSubmissionData = { ...newSubmissionData, [key]: [value] };
      }
    } else {
      newSubmissionData = { ...newSubmissionData, [key]: [value] };
    }
    setSelectedDetailData(newSubmissionData ?? {});
  };

  const handleDetailDataSelection = () => {
    let temp = [...selectedMedicData];
    const currentIndex = temp.findIndex(
      (item) => item.name === selectedMedicineId
    );
    temp[currentIndex] = {
      ...temp[currentIndex],
      detailData: selectedDetailData,
    };
    setSelectedMedicData(temp);
  };

  useEffect(() => {
    if (selectedDetailData && Object.keys(selectedDetailData).length) {
      handleDetailDataSelection();
    }
  }, [selectedDetailData]);

  console.info("selectedinvest", selectedMedicData);

  const splitTextIntoChunks = (text, chunkSize) => {
    const words = text.split(" ");
    const chunks = [];
    let currentChunk = "";

    for (let i = 0; i < words.length; i++) {
      if ((currentChunk + words[i]).length <= chunkSize) {
        currentChunk += words[i] + " ";
      } else {
        chunks.push(currentChunk.trim());
        currentChunk = words[i] + " ";
      }
    }

    if (currentChunk.trim().length > 0) {
      chunks.push(currentChunk.trim());
    }

    return chunks;
  };

  const renderSplitText = (text) => {
    return splitTextIntoChunks(text, 50).map((chunk, index) => (
      <React.Fragment key={index}>
        {index !== 0 && <br />}
        {chunk}
      </React.Fragment>
    ));
  };

  return (
    <>
      <div className={styles.data_box_wrap}>
        <div className={styles.medication_box_container}>
          <div className={styles.header}>
            <div className={styles.searchBox}>
              <Searchbox
                value={selected}
                options={searchValues}
                onSelect={handleSearchBox}
                onSearch={handleOnSearch}
                placeholder="Search"
              />
            </div>

            <button
              className={styles.add_new_button}
              onClick={() => {
                setAddOpen(true);
              }}
            >
              <span>Add new</span>
              <BlackAdd />
            </button>
          </div>

          <div className={styles.body}>
            <div className={styles.caption}>
              <ClockSmall />
              {name}
            </div>

            <div className={styles.data_list_wrap}>
              <div className={styles.data_list}>
                {initialData &&
                  initialData.length > 0 &&
                  initialData.map((each, key) => {
                    if (isSelected(each)) {
                      return (
                        <div
                          onClick={() => {
                            handleItemClickSelected(each);
                          }}
                          className={`${styles.data_list_item} ${
                            isSelected(each) && styles.data_list_item_selected
                          }`}
                          key={key}
                        >
                          <div>{renderSplitText(each?.name)}</div>
                          <div
                            onClick={(e) => {
                              handleAddIconClick(e, each);
                            }}
                            className={`${styles.addIcon} ${
                              !isSelected(each)
                                ? styles.addIconSelected
                                : styles.addIconNotSelected
                            }`}
                          >
                            <BlueAdd
                              isSelected={isSelected(each)}
                              scale={0.7}
                            />
                          </div>
                        </div>
                      );
                    }
                  })}
              </div>

              <div className={styles.data_list}>
                {initialData &&
                  initialData.length > 0 &&
                  initialData.slice(0, 10).map((each, key) => {
                    if (!isSelected(each)) {
                      return (
                        <div
                          onClick={() => {
                            handleItemClick(each);
                          }}
                          className={`${styles.data_list_item} ${
                            isSelected(each) && styles.data_list_item_selected
                          }`}
                          key={key}
                        >
                         <div>{renderSplitText(each?.name)}</div>

                          <div
                            onClick={(e) => {
                              handleAddIconClick(e, each);
                            }}
                            className={`${styles.addIcon} ${
                              !isSelected(each)
                                ? styles.addIconSelected
                                : styles.addIconNotSelected
                            }`}
                          >
                            <BlueAdd
                              isSelected={isSelected(each)}
                              scale={0.7}
                            />
                          </div>
                        </div>
                      );
                    }
                  })}
              </div>
            </div>
          </div>
        </div>

        <div
          className={`${styles.options_container} ${
            isOpen
              ? styles.options_container_open
              : styles.options_container_close
          }`}
        >
          <div className={styles.option_item}>
            <div className={styles.item_list}>
              <div className={`${styles.item} ${styles.item_title}`}>
                {selectedMedicineId}
              </div>
            </div>
          </div>
          <div className={styles.option_item}>
            <div className={styles.caption}>Note</div>

            <div className={styles.form_item}>
              <Textarea
                value={
                  selectedDetailData?.note?.length
                    ? selectedDetailData?.note[0]
                    : ""
                }
                onChange={(e) => {
                  handleSubChange({ key: "note", value: e.target.value });
                }}
                onPaste={(e) => {
                  e.preventDefault();
                  const pastedData = e.clipboardData.getData("text/plain");
                  const start = e.target.selectionStart;
                  const end = e.target.selectionEnd;
                  const currentValue = e.target.value;

                  // Calculate the available space
                  const availableSpace =
                    200 - (currentValue.length - (end - start));

                  // Truncate the pasted data if necessary
                  const truncatedPastedData = pastedData.substring(
                    0,
                    availableSpace
                  );

                  const newValue =
                    currentValue.substring(0, start) +
                    truncatedPastedData +
                    currentValue.substring(end);

                  // Use the existing handleSubChange function to update the state
                  handleSubChange({
                    key: "note",
                    value: newValue.substring(0, 200), // Ensure it doesn't exceed 200 characters
                  });

                  // Set cursor position after the pasted text
                  setTimeout(() => {
                    e.target.setSelectionRange(
                      start + truncatedPastedData.length,
                      start + truncatedPastedData.length
                    );
                  }, 0);
                }}
                className={styles.form_item_input}
                type="text"
                placeholder="Enter note here"
                maxLength={200}
              />
            </div>
          </div>
        </div>
      </div>

      <AddMedicineModal
        onSubmit={(e) => {
          handleAdd && addData(e);
        }}
        title={addTitle ? addTitle : "Add new"}
        showModal={isAddOpen}
        hidemodal={() => {
          setAddOpen(false);
        }}
      />
    </>
  );
}

export default InvestigationBox;
